import {toast} from 'react-toastify';

export function toastAclError() {
	toast.error('ليس لديك صلاحية للقيام بهذه العملية ');
}

export function toastUnexpectedError() {
	toast.error('حدث خطأ غير متوقع');
}
